export default __webpack_public_path__ + "static/dropdownMenu_cloud_right-51beb3f14700287dae655af72bf4c792.webp";